<template>

  <div style="position:relative">
    
    <gmap-map
    ref="mainMap"
    :center="center"
    :zoom="12"
    :options="{styles: gmapstyle}"/>

    <cockpit-addon
      v-if="addon_panel_show"
      :meta = "addon_display.meta"
      :attachments = "addon_display.attachments"
      @closeAddon="addon_panel_show=false">
    </cockpit-addon>

    <cockpit-switch 
      v-if="campaign"
      :options='campaign.zones'
      v-model="zone_index"/>
  </div>

</template>

<script>
import gmapstyle from '../mixins/gmapstyle.js'
import drawHeatmap from '../mixins/drawHeatmap.js'
import drawCars from '../mixins/drawCars.js'
import drawAddons from '../mixins/drawAddons.js'
import CockpitAddon from './CockpitAddon'
import CockpitSwitch from './CockpitSwitch'

export default {
  name: 'CockpitMap',
  props: ['campaign'],
  components: {
    CockpitAddon,
    CockpitSwitch
  },
  mixins: [
    drawHeatmap,
    drawCars,
    drawAddons
  ],
  data: function () {
    return {
      center: {
        lat: 48.2080586,
        lng: 16.3709961
      },
      heatmap: null,
      cars: [],
      addons: [],
      update_interval: 10000,
      smoother: 250,
      last_update: null,
      repeater: null,
      addon_panel_show: false,
      gmapstyle,
      zone_index: 0
    }
  },
  mounted () {
    this.draw()
  },
  watch: {
    campaign () {
      this.zone_index = 0
      this.draw()
    },
    zone_index () {
      this.panFrame()
    }
  },
  methods: {
    draw () {
      var self = this
      self.$Progress.set(50)

      self.$refs.mainMap.$mapCreated.then(
        () => {
          // CARS
          if (self.campaign) {
            self.drawCars()

            self.panFrame()

            self.drawAddons()
          }

          // ADDONS
          // self.drawAddons()

          // FRAMES

          // if (self.campaign.zones) {
          // } else {
          // // HEATMAP
          //   self.drawHeatmap(self.campaign.heatmap)
          // }

          self.$Progress.finish()
        }
      )
    },
    panFrame () {
      var self = this
      var map = self.$refs.mainMap.$mapObject
      var bounds = self.campaign.zones[self.zone_index].frame
      map.fitBounds(bounds)
      self.drawFrame()
    },
    drawFrame () {
      let self = this
      let map = self.$refs.mainMap.$mapObject
      let url = self.campaign.zones[self.zone_index].gz.json

      map.data.forEach(i => map.data.remove(i))
      map.data.loadGeoJson(url)
      map.data.setStyle({
        fillOpacity: '0',
        strokeColor: '#00b1eb'
      })

      let heatmapUrl = self.campaign.zones[self.zone_index].heatmap
      self.drawHeatmap(heatmapUrl)
    }
  }
}
</script>
<style scoped lang="stylus">
.vue-map-container
  width 100%
  height: calc(100vh - 250px)
</style>



// WEBPACK FOOTER //
// src/components/CockpitMap.vue